import { createPersistedStore } from "./createPersistedStore.ts";

export const Themes = [
    { id: "workleap-bleu", description: "Workleap Bleu", swatch: "#2545FF" },
    { id: "screen-green", description: "Screen Green", swatch: "#346200" },
    { id: "wednesday-pink", description: "Wednesday Pink", swatch: "#BE185D" },
    { id: "group-chat-lilac", description: "Group Chat Lilac", swatch: "#5B45E8" },
    { id: "mono-neutral", description: "Mono Neutral", swatch: "#525252" }
] as const;

export type Theme = (typeof Themes)[number]["id"];

const DEFAULT_THEME: Theme = "workleap-bleu";
const STORAGE_KEY = "theme";

function isTheme(value: string | null): value is Theme {
    return value !== null && Themes.some(t => t.id === value);
}

function applyTheme(theme: Theme) {
    const root = document.documentElement;

    for (const { id } of Themes) {
        root.classList.toggle(`theme-${id}`, id === theme);
    }
}

const store = createPersistedStore<Theme>({
    storageKey: STORAGE_KEY,
    getFallback: () => DEFAULT_THEME,
    isValid: isTheme,
    apply: applyTheme
});

export const setTheme = store.set;
export const useTheme = store.useValue;
export const useSetTheme = store.useSetValue;
